import { Element } from "@xmpp/xml"
import { ChatSettings } from "@/reducers/chatsSettingsSlice"
import { DataFormsParser } from "@/lib/formParser"
import { xml } from "@xmpp/client"

class ChatSettingsParser {
  static parseItem(item: Element): ChatSettings {
    const form = DataFormsParser.parse(item)
    const muted = form?.fields?.["muted"]?.values[0] === "1"
    const archived = form?.fields?.["archived"]?.values[0] === "1"

    return {
      chatJid: item.attrs.id,
      muted,
      archived,
    }
  }

  static parse(stanza: Element): ChatSettings | undefined {
    const eventNode =
      stanza.getChild("event", "http://jabber.org/protocol/pubsub#event") ||
      stanza.getChild("pubsub", "http://jabber.org/protocol/pubsub")
    if (!eventNode) return

    const itemsNode = eventNode.getChildByAttr(
      "node",
      "urn:slickshift:chat-settings:0",
    )
    if (!itemsNode) return

    const itemNode = itemsNode.getChildren("item")[0]
    if (!itemNode) return

    return ChatSettingsParser.parseItem(itemNode)
  }

  static toXml(chatSettings: ChatSettings): Element {
    return xml(
      "x",
      { xmlns: "jabber:x:data", type: "form" },
      xml(
        "field",
        { var: "muted", type: "boolean" },
        xml("value", {}, chatSettings.muted ? "1" : "0"),
      ),
      xml(
        "field",
        { var: "archived", type: "boolean" },
        xml("value", {}, chatSettings.archived ? "1" : "0"),
      ),
    )
  }
}

export default ChatSettingsParser
